import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store/index'
import { datadogRum } from '@datadog/browser-rum'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import { NODE_ENV, PROD, STAGING } from '@/helpers/env'

Vue.use(VueDOMPurifyHTML)
Vue.config.productionTip = false

// NODE_ENV is 'production' for both staging and production builds, so derive
// the RUM env from VUE_APP_API_ENV; local dev always reports 'development'.
const rumEnv =
  NODE_ENV === 'development'
    ? 'development'
    : PROD
    ? 'production'
    : STAGING
    ? 'staging'
    : NODE_ENV

datadogRum.init({
  applicationId: '86d64070-8739-48c3-ad26-45f019ad59df',
  clientToken: 'pube7a0da52333ff7941607c3f5b61b71c6',
  site: 'datadoghq.com',
  service: 'guest-reservations',
  env: rumEnv,
  version: process.env.VUE_APP_VERSION,
  sampleRate: 100,
  trackInteractions: true,
  // allow RUM to run when app loaded in an iframe
  useSecureSessionCookie: true,
  useCrossSiteSessionCookie: true,
  /**
   * From datadog support - filter error events of this type which are flooding
   * records and don't give us any value
   */
  beforeSend: event => {
    if (
      event.type === 'error' &&
      event.error.message.includes('Object Not Found Matching Id')
    ) {
      return false
    }
  },
})

datadogRum.startSessionReplayRecording()

new Vue({
  router,
  store,
  render: h => h(Vue.extend(App)),
}).$mount('#app')
